// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"zQ-z","inlineTitle":"AQ-z","sponsoredAdsWrapper":"BQ-z","marketplaceRecosWrapper":"CQ-z"};